import { trpc } from '@/shared/api';
import { usePresignedImageUpload } from '@/shared/lib';

/** 히어로 사진 업로드 — 발급(landing.presignHeroUpload) → S3 직접 PUT. */
export const useLandingHeroUpload = () => {
  const presignMutation = trpc.landing.presignHeroUpload.useMutation();

  return usePresignedImageUpload((contentType) => presignMutation.mutateAsync({ contentType }));
};
